import React from "react";
import { Modal, Button, notification, Alert } from "antd";
import { getSellerID } from "../../../../api/common";

const ApiKeyCopyModal = ({ copyModalVisible, handleCancel, apiKey }) => {
  const handleCopyKey = () => {
    navigator.clipboard.writeText(apiKey?.key)
      .then(() => {
        notification.success({
          message: 'Chave copiada com sucesso!',
          placement: 'topRight',
        });
      })
      .catch((error) => {
        console.error('Erro ao copiar a chave:', error);
        notification.error({
          message: 'Erro ao copiar a chave!',
          placement: 'topRight',
        });
      });
  };

  return (
    <Modal
      title="Chave Única"
      visible={copyModalVisible}
      onCancel={() => handleCancel()}
      footer={[
        <Button key="copy" type="primary" onClick={() => handleCopyKey()}>
          Copiar
        </Button>,
        <Button key="cancel" onClick={() => handleCancel()}>
          Cancelar
        </Button>,
      ]}
    >
      <Alert
        message="Aviso!"
        description={
          <>
          Não será possível recuperar esta chave novamente!
          <br />
          Por favor, copie e guarde-a em um local seguro.
          </>
        }
        type="warning"
        showIcon
      />
      <p>Sua API Key:<br/><strong>{apiKey?.key}</strong></p>
      <p>Seu Seller ID:<br/><strong>{getSellerID()}</strong></p>
    </Modal>
  );
};

export default ApiKeyCopyModal;
